import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    createMaterialWithdraw: () => {
        return HTTP.post('/lot/create_mat_withdraw', null,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    zoneList: () => {
        return HTTP.get('/lot/zone', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addZoneWithdraw: () => {
        return HTTP.get('/lot/add_zone_withdraw', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addMaterialWithdraw: (id) => {
        return HTTP.get('/lot/add_mat_withdraw?zone_id='+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    outZoneList: (id) => {
        return HTTP.get('/lot/out_zone?zone='+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    materialWithdraw: (data) => {
        return HTTP.post('/lot/material_withdraw',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    summarizeZoneList: (id) => {
        return HTTP.get('/lot/summarize_zone_get?zone='+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    summarizeZoneUpdate: (data) => {
        return HTTP.post('/lot/summarize_zone_update',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}